import LeadRow from "./LeadRow";

const th = "text-left text-[10px] font-semibold uppercase tracking-[0.2em] text-[#4A4A66] px-4 py-3 whitespace-nowrap";
const HEADERS = ["Contacted", "Registered", "Name", "Email", "Phone", "Instagram", "Referred by", "Message", "Opt-in", "Notes"];

export default function LeadsTable({ leads, onUpdate }) {
  if (!leads.length) {
    return <p data-testid="leads-empty" className="rounded-3xl bg-white border border-[#E3E3F0] p-10 text-center text-[#4A4A66]">No registrations yet.</p>;
  }
  return (
    <div className="rounded-3xl bg-white border border-[#E3E3F0] overflow-x-auto">
      <table data-testid="leads-table" className="w-full min-w-[1100px]">
        <thead className="border-b border-[#E3E3F0]">
          <tr>{HEADERS.map((h) => <th key={h} className={`${th} ${h === "Contacted" ? "text-center" : ""}`}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {leads.map((l) => <LeadRow key={l.id} lead={l} onUpdate={onUpdate} />)}
        </tbody>
      </table>
    </div>
  );
}
